






import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'

export default Vue.extend({
  name: 'PatientIndexColumn',
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number,
    toggleRowDetail: Function,
    row: Object as () => Mailing,
  },
  computed: {
    recordNumber (): number {
      return this.scope.pagination.currentPage * this.scope.pagination.pageSize - this.scope.pagination.pageSize + this.rowIndex + 1
    }
  }
})
